import { BankingValueObjectsCardTypeEnum } from 'generated/resources/graphql'

export const isVirtual = (card: { type: BankingValueObjectsCardTypeEnum }): boolean => {
  return card.type === 'virtual'
}
